<template>
  <div
    ref="controlRef"
    class="clinic-controls"
    :class="{ '-playing': isPlaying }"
  >
    <div class="arrow-container" alt="">
      <div class="arrow" @click="clickForward">
        <img ref="image" class="image" src="/icons/arrow-big.png" />
      </div>
    </div>
    <div class="blobs">
      <img src="/icons/indicator-blobs.svg" alt="indicator blobs" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useClinicControls } from '~/clinic-inside/utils/useClinicControls';

const props = defineProps<{
  scrollContainerEl: HTMLElement;
  progress: number;
  isPlaying?: boolean;
}>();

let controls: ReturnType<typeof useClinicControls>;
const image = ref<HTMLImageElement | null>(null);
const controlRef = ref<HTMLElement | null>(null);

onMounted(() => {
  controls = useClinicControls(props.scrollContainerEl, controlRef.value);
});

const clickForward = () => {
  controls.forward();
  if (image.value) {
    image.value.style.transform = 'scale(.98)';
    setTimeout(() => {
      image.value!.style.transform = '';
    }, 300);
  }
};
</script>

<style lang="scss" scoped>
.clinic-controls {
  position: absolute;
  inset: 0;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  justify-content: end;
  transition: opacity 0.3s ease-in-out;
  z-index: 20;

  &.-playing {
    display: none;
  }

  .arrow-container {
    display: flex;
    justify-content: center;

    .arrow:hover,
    .image {
      transform: scale(1.05);
      cursor: pointer;
    }

    .arrow {
      transform: scale(1);
      transition: transform 0.3s ease-in-out;
      height: 96px;
      width: fit-content;

      // margin-right: 5rem;
      margin-bottom: 3rem;
      background-position: center;
      background-size: contain;
      display: flex;
      flex-direction: column;
      justify-content: center;
      img {
        width: 30px;
      }
    }
  }

  &.last-step {
    .arrow-container {
      .arrow {
        img {
          transform: rotate(90deg);
        }
      }
    }
  }

  &.finished {
    opacity: 0 !important;
    pointer-events: none;
  }

  .blobs {
    position: absolute;
    width: 100%;
    bottom: -350px;
    z-index: -1;

    img {
      margin-inline: auto;
    }
  }
}
@media (--vs) {
  .clinic-controls {
    .arrow-container {
      justify-content: end;
      .arrow {
        height: 55px;
        margin-right: 1.625rem;
        margin-bottom: 1.5625rem;
        img {
          width: 21px;
        }
      }
    }
    .blobs {
      width: 110%;
      right: -25%;
      bottom: -320px;
      img {
        margin-left: auto;
        margin-right: 0;
      }
    }
  }
}
</style>
